import { onLangChange } from '@/hub-shared'
import ToastHelper from '@helpers/toast.helper'
import { useCallback, useEffect, useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Subscription } from 'rxjs'
import i18n from '../../i18n.shared'

export interface ServiceError {
  statusCode?: number
  error?: string
  message: string
  errorCode?: string
  errorDescription?: string
  stack?: Array<any>
}

export default (messages: any, translationModule: string) => {
  const toast = useMemo(() => new ToastHelper().toast, [])
  const { t } = useTranslation()
  const onLangChangeSubscription = useRef<Subscription | undefined>(undefined)

  useEffect(() => {
    onLangChangeSubscription.current = onLangChange.subscribe((lang) => {
      i18n.changeLanguage(lang)
    })
    return () => {
      onLangChangeSubscription.current?.unsubscribe()
    }
  }, [])
  const showMessage = useCallback(
    (error: ServiceError | null, type = 'warning', onClick?: () => void) => {
      let messageError: string = t('errors.default')
      if (error?.errorCode && Object.keys(messages).includes(error?.errorCode)) {
        messageError = t(`errors.${translationModule}.${messages[error?.errorCode]}`)
      } else if (error?.errorDescription && Object.keys(messages).includes(error?.errorDescription)) {
        messageError = t(`errors.${translationModule}.${messages[error?.errorDescription]}`)
      } else if (error?.message) {
        messageError = error?.message
      }
      toast[type](messageError, {
        closeButton: true,
        className: 'full text-bold',
        position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
        duration: 3600000,
        notOverClick: true,
        immediately: true,
        onClick,
      })
    },
    [toast, t, translationModule, messages]
  )

  return { showMessage }
}
